import React from 'react';
import ProductAdvertising from '../../../components/ProductAdvertising';
import { useIntl } from 'react-intl';

const Newsletters = () => {

    const textTranslator = useIntl();

    const data = {
        id: 30,
        id_en: 338,
        context: 'newsletter',
        title: textTranslator.formatMessage({ id: 'products.blocs.newsletter' })
    }
    return (
        <div>
            <ProductAdvertising data={data} />
        </div>
    );
};

export default Newsletters;